import { useTranslation, Trans } from "react-i18next";
import React, { useState } from "react";
import { Button } from "../shared/Button/Button";
import { Modal } from "semantic-ui-react";

const WEB_VERSION_V2_URL = `https://${process.env.REACT_APP_V2_PATH}`;

const setupUrlMap: Record<string, string> = {
  zapier: `${WEB_VERSION_V2_URL}/integrations/third-party/zapier/setup`,
  make: `${WEB_VERSION_V2_URL}/integrations/third-party/make/setup`,
  sleekflowApi: `${WEB_VERSION_V2_URL}/integrations/direct-api/platform-api/setup`,
  salesforceMarketingCloud: `${WEB_VERSION_V2_URL}/integrations/marketing/salesforce-marketing-cloud/setup`,
  salesforce: `${WEB_VERSION_V2_URL}/integrations/crm/salesforce-crm/setup`,
  hubspot: `${WEB_VERSION_V2_URL}/integrations/crm/hubspot/setup`,
} as const;

export function ChannelDeprecatedInFavorOfV2(props: { channelName: string }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const helpUrl =
    setupUrlMap[props.channelName] ?? `${WEB_VERSION_V2_URL}/integrations`;
  let addLabel = t("channels.selection.button.add");
  if (props.channelName === "salesforceMarketingCloud") {
    addLabel = t("channels.selection.button.addShort");
  }

  return (
    <>
      <Button customSize={"sm"} onClick={() => setOpen(true)}>
        {addLabel}
      </Button>
      <Modal
        open={open}
        className="contact-exceed-modal"
        style={{
          width: "614px",
          boxShadow: "0px 0px 10px 3px var(--GRAY-SHADOW) !important",
        }}
      >
        <Modal.Content
          className="_content"
          style={{
            paddingTop: "21px",
            paddingRight: 0,
            paddingBottom: "29px",
          }}
        >
          <div className="container">
            <div
              className="header"
              style={{ fontSize: "20px", padding: 0, textAlign: "center" }}
            >
              {t(
                "channels.deprecatedInFavourOfV2.title",
                "New version is now available"
              )}
            </div>
            <div className="content" style={{ textAlign: "center" }}>
              <Trans i18nKey={"channels.deprecatedInFavourOfV2.description"}>
                We've migrated this feature to the latest version. Explore the
                new features and enhancements by visiting SleekFlow 2.0. For
                more details, please visit our{" "}
                <a
                  href="https://help.sleekflow.io/en_US/channels"
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  Help Center
                </a>{" "}
                or contact our support team.
              </Trans>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "16px",
                justifyContent: "center",
              }}
            >
              <a
                className="ui button primary"
                href={helpUrl}
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                {t(
                  "channels.deprecatedInFavourOfV2.continue",
                  "Continue in SleekFlow 2.0"
                )}
              </a>
              <Button onClick={() => setOpen(false)}>
                {t("channels.deprecatedInFavourOfV2.cancel", "Cancel")}
              </Button>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    </>
  );
}
